import React, { Component } from 'react';
import * as api from '../api/api';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryText,
  ListItemGraphic,
  ListItemMeta
} from 'rmwc/List';

import { Link } from 'react-router-dom'

import StatusMessage from '../util/StatusMessage';

class TPORegistrationDetails extends Component{

  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      data: {
       'registration': false,
       'payment': false,
      }
    };
  }
    
  componentDidMount() {

    let data = Object.assign({}, this.state.data)
    
    api.fetchTPORegStatus(this.props.user.accessToken)
    .then((result) => {
      if(result.status === 'success'){
        if(result.data.registration){
          data.registration = true
          if(result.data.payment)
            data.payment = true
        }
        else{
          this.props.history.push("/portal/app/tpo_registration")
        }  
      }

      this.setState({data: data})
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
    })

  }
    
  render() {
    
    let contents

    if(this.state.data.registration){
      if(this.state.data.payment){
        contents = (
            <div>
              <br/><br/>
              <Typography use="subtitle1">You have already registered for TPO 2020</Typography>
              <br/><br/>
              <Typography use="subtitle1">Please click on the </Typography>
              <Link to="/portal/app/my_registrations">My Registrations </Link>
              <Typography use="subtitle1"> &nbsp;section to download your invoice</Typography>
            </div>        
          )   
      }
      else{
        contents = (
             <div>
             <br/><br/><br/><br/>
              <Typography use="subtitle1">You have started registering for TPO 2020</Typography>
              <br/><br/>
              <Typography use="subtitle1">Please click on the </Typography>
              <Link to="/portal/app/my_registrations">My Registrations </Link>
              <Typography use="subtitle1"> &nbsp; section to complete your payment</Typography>
             
            </div>       
          )
      }
    }

    return (
      <div class="mdc-layout-grid">
        <div class="mdc-layout-grid__inner"> 
          <div class="mdc-layout-grid__cell--span-10">
            <Typography use="headline5">TPO 2020 Registration</Typography>

            <StatusMessage error_msg = {this.state.errorMsg}/>
            {contents}

          <div class="mdc-layout-grid__cell--span-1"></div>
          <div class="mdc-layout-grid__cell--span-1"></div>
        </div>
      </div>
    </div>
    )
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TPORegistrationDetails);



// WEBPACK FOOTER //
// ./src/views/TPORegistrationDetails.jsx